module.exports = __webpack_public_path__ + "static/media/smartCity_illustration.b2521b43.png";